<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="180px">
      <el-form-item label="类型名称：" prop="name">
        <el-input v-model.trim="form.name" clearable placeholder="类型名称"></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="info">
        <el-input
          v-model.trim="form.info"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="描述"
          resize="none"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        id: '',
        name: '',
        info: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写类型名称',
            trigger: ['blur', 'change']
          }
        ],
        info: [
          {
            required: true,
            message: '请填写描述',
            trigger: ['blur', 'change']
          }
        ]
      },
      addApi: this.$api.basicdata.knowledge_type_add,
      updateApi: this.$api.basicdata.knowledge_type_update
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row)
    }
  },
  methods: {
    queryDetail(row) {
      this.form = JSON.parse(JSON.stringify(row))
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            id: this.form.id,
            name: this.form.name,
            info: this.form.info
          }

          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
